import * as Utils from '@ext/index';


export class Tipos {

    constructor( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos {

        if ( id === this.ContraEntrega.Id )
            return this.ContraEntrega;
        else if ( id === this.Propio.Id )
            return this.Propio;
        else if ( id === this.MercadoEnvios.Id )
            return this.MercadoEnvios;
        else if ( id === this.Flex.Id )
            return this.Flex;
        else if ( id === this.RetiraCliente.Id )
            return this.RetiraCliente;
        else if ( id === this.EnvioGratis.Id )
            return this.EnvioGratis;
        else if ( id === this.NoEspecificado.Id )
            return this.NoEspecificado;

        return new Tipos( id, id );
    }

    public static readonly ContraEntrega: Tipos = new Tipos( 'contraentrega', 'Contraentrega' );
    public static readonly Propio: Tipos = new Tipos( 'propio', 'A cuenta de la empresa' );
    public static readonly MercadoEnvios: Tipos = new Tipos( 'mercado-envios', 'MercadoEnvios' );
    public static readonly Flex: Tipos = new Tipos( 'mercado-envios-flex', 'MercadoEnvios Flex' );
    public static readonly RetiraCliente: Tipos = new Tipos( 'retira-cliente', 'Retira cliente' );
    public static readonly EnvioGratis: Tipos = new Tipos( 'envio-gratis', 'Envio Gratis' );
    public static readonly NoEspecificado: Tipos = new Tipos( 'no-especificado', 'No especificado' );

    public static Options: Array<Tipos> = [
        Tipos.ContraEntrega,
        Tipos.Propio,
        Tipos.MercadoEnvios,
        Tipos.Flex,
        Tipos.RetiraCliente,
        Tipos.EnvioGratis,
        Tipos.NoEspecificado,
    ];


    public get esPropio(): boolean { return this.Id === Tipos.Propio.Id; }
    public get esContraEntrega(): boolean { return this.Id === Tipos.ContraEntrega.Id; }
    public get esMercadoEnvios(): boolean { return this.Id === Tipos.MercadoEnvios.Id; }
    public get esFlex(): boolean { return this.Id === Tipos.Flex.Id; }
    public get esEnvioGratis(): boolean { return this.Id === Tipos.EnvioGratis.Id; }
    public get esRetiraCliente(): boolean { return this.Id === Tipos.RetiraCliente.Id; }
    public get esNoEspecificado(): boolean { return this.Id === Tipos.NoEspecificado.Id; }
}

export class Plataformas {

    constructor( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Plataformas {

        if ( id === this.Propia.Id )
            return this.Propia;
        if ( id === this.MercadoEnvios.Id )
            return this.MercadoEnvios;

        return new Plataformas( id, id );
    }

    public static readonly Propia: Plataformas = new Plataformas( 'propia', 'Propia' );
    public static readonly MercadoEnvios: Plataformas = new Plataformas( 'mercado-envios', 'MercadoEnvios' );

    public static Options: Array<Plataformas> = [
        Plataformas.Propia,
        Plataformas.MercadoEnvios,
    ];

}


export class Estados {

    constructor( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados {

        if ( id === this.Creado.Id )
            return this.Creado;
        else if ( id === this.Descargado.Id )
            return this.Descargado;
        else if ( id === this.EsperandoAutorizacion.Id )
            return this.EsperandoAutorizacion;
        else if ( id === this.NoAutorizado.Id )
            return this.NoAutorizado;
        else if ( id === this.Pendiente.Id )
            return this.Pendiente;
        else if ( id === this.Preparando.Id )
            return this.Preparando;
        else if ( id === this.Facturado.Id )
            return this.Facturado;
        else if ( id === this.ListoParaDespachar.Id )
            return this.ListoParaDespachar;
        else if ( id === this.ListoParaRetirar.Id )
            return this.ListoParaRetirar;
        else if ( id === this.Despachado.Id )
            return this.Despachado;
        else if ( id === this.Entregado.Id )
            return this.Entregado;
        else if ( id === this.NoEntregado.Id )
            return this.NoEntregado;
        else if ( id === this.Devuelto.Id )
            return this.Devuelto;
        else if ( id === this.Cancelado.Id )
            return this.Cancelado;
        else if ( id === this.ProcesadoFueraDeSistema.Id )
            return this.ProcesadoFueraDeSistema;


        return new Estados( id, id );
    }

    public static readonly Creado: Estados = new Estados( 'creado', 'Creado' );
    public static readonly Descargado: Estados = new Estados( 'descargado', 'Descargado' );
    public static readonly EsperandoAutorizacion: Estados = new Estados( 'esperando-autorizacion', 'Esperando autorización' );
    public static readonly NoAutorizado: Estados = new Estados( 'no-autorizado', 'No autorizado' );
    public static readonly Pendiente: Estados = new Estados( 'pendiente', 'Pendiente' );
    public static readonly Preparando: Estados = new Estados( 'en-proceso', 'Preparando' );
    public static readonly Facturado: Estados = new Estados( 'facturado', 'Facturado' );
    public static readonly ListoParaDespachar: Estados = new Estados( 'listo-para-despachar', 'Listo para depachar' );
    public static readonly ListoParaRetirar: Estados = new Estados( 'listo-para-retirar', 'Listo para retirar' );
    public static readonly Despachado: Estados = new Estados( 'despachado', 'Despachado' );
    public static readonly Entregado: Estados = new Estados( 'entregado', 'Entregado' );
    public static readonly NoEntregado: Estados = new Estados( 'no-entregado', 'No entregado' );
    public static readonly Devuelto: Estados = new Estados( 'devuelto', 'Devuelto' );
    public static readonly Cancelado: Estados = new Estados( 'cancelado', 'Cancelado' );
    public static readonly ProcesadoFueraDeSistema: Estados = new Estados( 'fuera-de-sistema', 'Fuera de sistema' );

    public static Options: Array<Estados> = [
        Estados.Creado,
        Estados.Descargado,
        Estados.EsperandoAutorizacion,
        Estados.NoAutorizado,
        Estados.Pendiente,
        Estados.Preparando,
        Estados.Facturado,
        Estados.ListoParaDespachar,
        Estados.ListoParaRetirar,
        Estados.Despachado,
        Estados.Entregado,
        Estados.NoEntregado,
        Estados.Devuelto,
        Estados.Cancelado,
        Estados.ProcesadoFueraDeSistema,
    ];

    public get esCreado(): boolean { return this.Id === Estados.Creado.Id; }
    public get esDescargado(): boolean { return this.Id === Estados.Descargado.Id; }
    public get esEsperandoAutorizacion(): boolean { return this.Id === Estados.EsperandoAutorizacion.Id; }
    public get esNoAutorizado(): boolean { return this.Id === Estados.NoAutorizado.Id; }
    public get esPendiente(): boolean { return this.Id === Estados.Pendiente.Id; }
    public get esPreparando(): boolean { return this.Id === Estados.Preparando.Id; }
    public get esFacturado(): boolean { return this.Id === Estados.Facturado.Id; }
    public get esListoParaDespachar(): boolean { return this.Id === Estados.ListoParaDespachar.Id; }
    public get esListoParaRetirar(): boolean { return this.Id === Estados.ListoParaRetirar.Id; }
    public get esDespachado(): boolean { return this.Id === Estados.Despachado.Id; }
    public get esEntregado(): boolean { return this.Id === Estados.Entregado.Id; }
    public get esNoEntregado(): boolean { return this.Id === Estados.NoEntregado.Id; }
    public get esDevuelto(): boolean { return this.Id === Estados.Devuelto.Id; }
    public get esCancelado(): boolean { return this.Id === Estados.Cancelado.Id; }


    public get Mensaje(): { Mensaje: string, Auto: boolean; } {

        if ( this.esCreado ) return { Mensaje: '', Auto: true };
        else if ( this.esDescargado ) return { Mensaje: '', Auto: true };
        else if ( this.esEsperandoAutorizacion ) return { Mensaje: '', Auto: true };
        else if ( this.esNoAutorizado ) return { Mensaje: 'No autorizar', Auto: false };
        else if ( this.esPendiente ) return { Mensaje: 'Autorizar', Auto: false };
        else if ( this.esPreparando ) return { Mensaje: '', Auto: true };
        else if ( this.esFacturado ) return { Mensaje: 'Facturado', Auto: false };
        else if ( this.esListoParaRetirar ) return { Mensaje: '', Auto: true };
        else if ( this.esListoParaDespachar ) return { Mensaje: '', Auto: true };
        else if ( this.esDespachado ) return { Mensaje: 'Despachado', Auto: false };
        else if ( this.esEntregado ) return { Mensaje: 'Entregado', Auto: false };
        else if ( this.esNoEntregado ) return { Mensaje: 'No entregado', Auto: false };
        else if ( this.esDevuelto ) return { Mensaje: 'Devuelto', Auto: false };
        else if ( this.esCancelado ) return { Mensaje: 'Cancelar', Auto: false };

        return { Mensaje: '', Auto: true };
    }
    public get Inicial(): boolean {

        return this.Id === Estados.EsperandoAutorizacion.Id ||
            this.Id === Estados.Creado.Id ||
            this.Id === Estados.Descargado.Id ||
            this.Id === Estados.Pendiente.Id;
    }
}